import { render, staticRenderFns } from "./RinvPL.vue?vue&type=template&id=fd80d67a"
import script from "./RinvPL.vue?vue&type=script&lang=js"
export * from "./RinvPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports